import ReportingCategoriesList from './ReportingCategoriesList'

const ReportingCategories = () => {
  return (
    <div className="items">
      <div className="header">
        <ul className="header__menu">
          <li className="header__menu-item">Name</li>
          <li className="header__menu-item">Assigned Items</li>
        </ul>
      </div>
      <ReportingCategoriesList />
    </div>
  )
}

export default ReportingCategories
